/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], () => {
	class Internal {
		constructor(options) {
			this.view = options.view;
		}

		destroy() {
			this.view = null;
		}

		/**
		 * Only used for our internal API.  Should not be used unless absolutely necessary and Ok'ed by code owners.
		 */
		getBoardModel() {
			return this.view.boardModel;
		}
	}

	return Internal;
});